/**
 * ユーザー情報の型定義
 */
export interface User {
  readonly id: string;
  readonly userName: string;
  readonly roleId: number;
  readonly roleName: string;
  readonly siteId: number | null;
  readonly siteName: string | null;
  readonly isActive: boolean;
  readonly sessionDurationMinutes: number | null;
  readonly createdAt: string;
  readonly updatedAt: string;

  // 2FA用フィールド
  readonly email: string | null;
  readonly twoFactorEnabled: boolean;
}

/**
 * ユーザー作成パラメータ
 */
export interface CreateUserParams {
  readonly userName: string;
  readonly password: string;
  readonly roleId: number;
  readonly siteId?: number | null;
  readonly isActive?: boolean;
  readonly sessionDurationMinutes?: number | null;
}

/**
 * ユーザー更新パラメータ
 */
export interface UpdateUserParams {
  readonly userName?: string;
  readonly password?: string;
  readonly roleId?: number;
  readonly siteId?: number | null;
  readonly isActive?: boolean;
  readonly sessionDurationMinutes?: number | null;

  // 2FA用パラメータ
  readonly email?: string | null;
  readonly twoFactorEnabled?: boolean;
}

/**
 * 信頼済みデバイス情報
 */
export interface TrustedDevice {
  readonly id: number;
  readonly ipAddress: string;
  readonly userAgent: string | null;
  readonly trustedUntil: string;
  readonly lastUsedAt: string;
  readonly createdAt: string;
}

/**
 * ロール情報
 */
export interface Role {
  readonly id: number;
  readonly roleName: string;
}

/**
 * サイト情報
 */
export interface Site {
  readonly id: number;
  readonly siteName: string;
}

/**
 * ロールID定数
 */
export const ROLE_ID = {
  DEV_USER: 1,
  MCM_USER: 2,
  SITE_USER: 3,
  SITE_VIEWER: 4,
} as const;

export type RoleId = (typeof ROLE_ID)[keyof typeof ROLE_ID];

/**
 * サイト制限が必要なロール
 */
export const SITE_RESTRICTED_ROLES: readonly RoleId[] = [ROLE_ID.SITE_USER, ROLE_ID.SITE_VIEWER];

/**
 * サイト制限ロールかどうか判定
 */
export const isSiteRestrictedRole = (roleId: number): boolean => {
  return SITE_RESTRICTED_ROLES.includes(roleId as RoleId);
};
